import { createSlice } from '@reduxjs/toolkit';

const accessSlice = createSlice({
    name: 'access',
    initialState: {
        loaded: false,
        paid: false,
        hasPropsUpgrade: false,
        planKey: '',
        planLabel: '',
        monthlyCredits: 0,
        remainingCredits: 0,
        creditsUsed: 0,
    },
    reducers: {
        setAccess(state, action) {
            state.paid = Boolean(action.payload?.paid);
            state.hasPropsUpgrade = Boolean(action.payload?.hasPropsUpgrade);
            state.planKey = String(action.payload?.planKey || '');
            state.planLabel = String(action.payload?.planLabel || '');
            state.monthlyCredits = Number(action.payload?.monthlyCredits || 0);
            state.remainingCredits = Number(action.payload?.remainingCredits || 0);
            state.creditsUsed = Number(action.payload?.creditsUsed || 0);
            state.loaded = true;
        },
        clearAccess(state) {
            state.loaded = false;
            state.paid = false;
            state.hasPropsUpgrade = false;
            state.planKey = '';
            state.planLabel = '';
            state.monthlyCredits = 0;
            state.remainingCredits = 0;
            state.creditsUsed = 0;
        },
    },
});

export const { setAccess, clearAccess } = accessSlice.actions;
export default accessSlice.reducer;
